import React from "react";
import { Auth, I18n } from 'aws-amplify';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { TERM_VER, API_STATUS } from "../../../configures/val.js";
import authCheck, { getInvoiceList, getInvoiceReport } from '../../util/callApi.js';
import checkTermsVer from '../../util/checkTermsVer.js';
import LapDialog from '../../util/laplaceDialog.js';

export default class InvoiceList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      termVerError: false,
      invoiceListStatus: API_STATUS.LOADING,
      rows: []
    };
    this.contentsList = [];
  }
  async componentDidMount() {
    this._isMounted = true;
    this.props.updateHeader('invoiceList');
    try {
      const authRet = await authCheck();
      if (authRet.result === 'NG') {
        throw new Error('authentication failed');
      } else {
        const isLowVer = checkTermsVer(authRet.data, 'custom:agreed_term', TERM_VER, 'ver');
        if (isLowVer) {
          this.setState({
            invoiceListStatus: API_STATUS.LOADING,
            termVerError: true,
          });
          return;
        }
      }
    } catch (error) {
      window.history.pushState('', '', '/');
      this.props.authStateChange('signIn');
      return;
    }
    try {
      const invoiceList = await getInvoiceList();
      if(invoiceList.result === 'NG') {
        this.setState({
          invoiceListStatus: API_STATUS.NO_RESPONSE,
          rows: []
        });
        return;
      }
      this.setState({
        invoiceListStatus: API_STATUS.OK,
        rows: invoiceList.data
      });
      return;
    } catch (error) {
      console.log('Invoicelist API Error');
      console.log(error);
      this.setState({
        invoiceListStatus: API_STATUS.NO_RESPONSE,
        rows: []
      });
      return;
    }
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  reshapeNumToPrice = (num) => {
    return num.toLocaleString('ja', {style: 'currency', currency: 'JPY'});
  }
  /*
   *  掲載日の文字列からパラメータ文字列を作り、
   *  pdf を取得する
   *
   * */
  async getPdf (e, fileName) {
    e.preventDefault();
    let ret;
    ret = await getInvoiceReport(fileName);
    if (ret.result === 'NG') {
      alert(I18n.get('Fail to get invoice report.'));
    }
  }
  async closeTermVerError (that) {
    const user = await Auth.currentAuthenticatedUser();
    that.props.authStateChange('reagreeTermsDocs', user);
    this.setState({
      termVerError: false
    });
    return;
  }
  render() {
    if (this.state.invoiceListStatus === API_STATUS.OK) {
      return (
        <>
        <p className="rakurakumeisai">
            {I18n.get('From January 2024 onward, we have uploaded invoices to "Rakuraku Meisai".')}<br />
            {I18n.get('If you have not received any notification from "Rakuraku Meisai", please contact us at the following.')}<br />
            <br />
            {I18n.get('Laplace System Co., Ltd., Administration Department, Finance & Accounting Division, Subscription Section')}<br />
            {I18n.get('TEL: 075-604-4731 (weekdays 9:00～17:30) E-mail: accounting@lapsys.co.jp')}
        </p>
        <div className={"mypageContainer"}>
          <p className="mypageTitle"><span className="mypageTitleIcon"></span>{I18n.get('Invoices')}</p>
          <dl className="mypageUserinfoItem ">
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{I18n.get('Invoice date')}</TableCell>
                  <TableCell>{I18n.get('Subject')}</TableCell>
                  <TableCell id="invoiceListPriceThCol">{I18n.get('Amount (tax included)')}</TableCell>
                  <TableCell id="invoiceListPdfThCol">{I18n.get('Invoice')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.rows.map(row => (
                <TableRow key={row.invoiceName}>
                  <TableCell component="th" scope="row">
                    {row.claimDateText}
                  </TableCell>
                  <TableCell>{row.invoiceName}</TableCell>
                  <TableCell id="invoiceListPriceCol">{this.reshapeNumToPrice(row.totalPrice)}</TableCell>
                  <TableCell id="invoiceListPdfCol"><a className="mypageNoabsoluteNormalButton blue" href={row.claimDateText} onClick={(e) => {this.getPdf(e, row.fileName)}}>PDF</a></TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </dl>
        </div>
        </>
      );
    } else if (this.state.invoiceListStatus === API_STATUS.LOADING) {
      return(
        <>
          <p>{I18n.get('Now loading...')}</p>
          <LapDialog
            title={''}
            contentElem={
              <div>
                <p>{I18n.get('Terms of Service is updated.')}</p>
                <p>{I18n.get('Please reconfirm it.')}</p>
              </div>
            }
            firstButtonText={'OK'}
            firstButtonFunc={() => this.closeTermVerError(this)}
            open={this.state.termVerError}
            toClose={() => {return;}}
          />
        </>
      );
    } else {
      return (
        <p>{I18n.get('Fail to get invoice list.')}</p>
      );
    }
  }
}
